import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { usePostHog } from 'posthog-js/react'
import { PostHogEvent } from './posthog/events'

const getScreenName = (pathname: string) => {
  const trimmed = pathname.replace(/^\/+/, '')
  return trimmed.length > 0 ? trimmed : 'root'
}

const PostHogRouteTracker = () => {
  const location = useLocation()
  const posthog = usePostHog()

  useEffect(() => {
    if (!posthog) {
      return
    }

    posthog.capture('$pageview', {
      $current_url: window.location.href,
    })

    posthog.capture(PostHogEvent.SCREEN_VIEW, {
      screen_name: getScreenName(location.pathname),
      path: location.pathname,
      search: location.search,
    })
  }, [posthog, location.pathname, location.search, location.hash])

  return null
}

export default PostHogRouteTracker
